import { render, staticRenderFns } from "./kyc-withdraw-address.vue?vue&type=template&id=7f915363&scoped=true&"
import script from "./kyc-withdraw-address.vue?vue&type=script&lang=js&"
export * from "./kyc-withdraw-address.vue?vue&type=script&lang=js&"
import style0 from "./kyc-withdraw-address.vue?vue&type=style&index=0&id=7f915363&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f915363",
  null
  
)

export default component.exports